import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';

type CacheKey = string;

interface CacheEntry {
    response: HttpResponse<any>;
    addedAt: number;
    etag?: string;
}

@Injectable({ providedIn: 'root' })
export class HttpCacheService {

    private cache = new Map<CacheKey, CacheEntry>();

    get(key: CacheKey): CacheEntry | undefined {
        return this.cache.get(key);
    }

    set(key: CacheKey, entry: CacheEntry): void {
        this.cache.set(key, entry);
    }

    delete(key: CacheKey): void {
        this.cache.delete(key);
    }

    clearByPrefix(prefix: string): void {
        for (const k of this.cache.keys()) {
            if (k.startsWith(prefix)) this.cache.delete(k);
        }
    }

    clearAll(): void {
        this.cache.clear();
    }

    buildCacheKey(req: HttpRequest<any>): string {
        const url = req.urlWithParams;
        const accept = req.headers.get('Accept') ?? '';
        return `${req.method}|${url}|${accept}`;
    }

}

